import _asyncToGenerator from "E:/dayinjia/Vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/qrcodeWX.jpg';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-171890f4"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container"
};
var _hoisted_2 = {
  class: "popover"
};
var _hoisted_3 = {
  class: "eye"
};
var _hoisted_4 = {
  class: "loginTips"
};
var _hoisted_5 = {
  class: "right"
};

var _hoisted_6 = /*#__PURE__*/_createTextVNode("忘记密码");

var _hoisted_7 = /*#__PURE__*/_createTextVNode("注册账号");

var _hoisted_8 = /*#__PURE__*/_createTextVNode("获取验证码");

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h2", null, "微信扫码登录", -1);
});

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "image"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })], -1);
});

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h4", null, "请使用微信 扫描二维码登录", -1);
});

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h4", null, "关注大印家谱", -1);
});

var _hoisted_13 = {
  class: "tips"
};

var _hoisted_14 = /*#__PURE__*/_createTextVNode("注册账号");

import { ref } from 'vue';
import { useStore } from 'vuex';
export default {
  setup: function setup(__props) {
    var _this = this;

    var store = useStore();
    var rememberUser = ref(true);
    var form = ref({
      phone: localStorage.getItem('account'),
      password: ''
    });
    var rules = ref({
      phone: [{
        required: true,
        message: '请输入用户名',
        trigger: 'blur'
      }],
      password: [{
        required: true,
        message: '请输入密码',
        trigger: 'blur'
      }]
    });
    var formRef = ref(null);

    var handleLogin = function handleLogin() {
      formRef.value.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!valid) {
                    _context.next = 5;
                    break;
                  }

                  localStorage.setItem('rememberUser', rememberUser.value);
                  store.dispatch('app/login', form.value);
                  _context.next = 7;
                  break;

                case 5:
                  console.log('error submit!!');
                  return _context.abrupt("return", false);

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    };

    var activeName = ref('first');

    var tabsChange = function tabsChange() {};

    var loginType = ref('user');
    var loginText = ref('微信登录');
    var loginIcon = ref('qrCode');

    var toggleCode = function toggleCode() {
      if (loginType.value === 'user') {
        loginType.value = 'app';
        loginText.value = '账号登录';
        loginIcon.value = 'computer';
      } else {
        loginType.value = 'user';
        loginText.value = '微信登录';
        loginIcon.value = 'qrCode';
      }
    };

    var passwordType = ref('password');

    var changeType = function changeType() {
      if (passwordType.value === 'password') {
        passwordType.value = 'text';
      } else {
        passwordType.value = 'password';
      }
    };

    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_form_item = _resolveComponent("el-form-item");

      var _component_el_form = _resolveComponent("el-form");

      var _component_el_checkbox = _resolveComponent("el-checkbox");

      var _component_router_link = _resolveComponent("router-link");

      var _component_el_tab_pane = _resolveComponent("el-tab-pane");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_tabs = _resolveComponent("el-tabs");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "r-t-mark",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return toggleCode(_this);
        })
      }, [_createVNode(_component_svg_icon, {
        icon: loginIcon.value,
        class: "icon"
      }, null, 8, ["icon"]), _createElementVNode("span", _hoisted_2, _toDisplayString(loginText.value), 1)]), _createElementVNode("div", {
        class: "user",
        style: _normalizeStyle({
          display: loginType.value == 'user' ? 'block' : 'none'
        })
      }, [_createVNode(_component_el_tabs, {
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
          return activeName.value = $event;
        }),
        class: "tabs",
        onTabClick: tabsChange
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_tab_pane, {
            label: "密码登录",
            name: "first"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form, {
                ref_key: "formRef",
                ref: formRef,
                model: form.value,
                class: "login-form",
                rules: rules.value
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_form_item, {
                    prop: "phone"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_svg_icon, {
                        icon: "user"
                      }), _createVNode(_component_el_input, {
                        modelValue: form.value.phone,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                          return form.value.phone = $event;
                        })
                      }, null, 8, ["modelValue"])];
                    }),
                    _: 1
                  }), _createVNode(_component_el_form_item, {
                    prop: "password"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_svg_icon, {
                        icon: "password"
                      }), _createVNode(_component_el_input, {
                        modelValue: form.value.password,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                          return form.value.password = $event;
                        }),
                        type: passwordType.value
                      }, null, 8, ["modelValue", "type"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_svg_icon, {
                        icon: passwordType.value === 'password' ? 'eye' : 'eye-open',
                        onClick: changeType
                      }, null, 8, ["icon"])])];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }, 8, ["model", "rules"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_checkbox, {
                modelValue: rememberUser.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                  return rememberUser.value = $event;
                }),
                label: "记住账号",
                size: "large"
              }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_router_link, {
                to: "resetPwd"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_6];
                }),
                _: 1
              }), _createVNode(_component_router_link, {
                to: "register"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_7];
                }),
                _: 1
              })])])];
            }),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "短信登录",
            name: "second"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form, {
                ref_key: "formRef",
                ref: formRef,
                model: form.value,
                class: "login-form",
                rules: rules.value
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_form_item, {
                    prop: "username"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_svg_icon, {
                        icon: "user"
                      }), _createVNode(_component_el_input, {
                        modelValue: form.value.username,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
                          return form.value.username = $event;
                        })
                      }, null, 8, ["modelValue"])];
                    }),
                    _: 1
                  }), _createVNode(_component_el_form_item, {
                    prop: "shield"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_svg_icon, {
                        icon: "shield"
                      }), _createVNode(_component_el_input, {
                        modelValue: form.value.shield,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
                          return form.value.shield = $event;
                        }),
                        class: "inputWithButton"
                      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
                        plain: ""
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_8];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }, 8, ["model", "rules"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["modelValue"])], 4), _createElementVNode("div", {
        class: "app",
        style: _normalizeStyle({
          display: loginType.value == 'app' ? 'block' : 'none'
        })
      }, [_hoisted_9, _hoisted_10, _hoisted_11, _hoisted_12, _createElementVNode("div", _hoisted_13, [_createElementVNode("a", {
        onClick: _cache[7] || (_cache[7] = function ($event) {
          return toggleCode();
        })
      }, "账号登录"), _createVNode(_component_router_link, {
        to: "register"
      }, {
        default: _withCtx(function () {
          return [_hoisted_14];
        }),
        _: 1
      })])], 4)]), _createVNode(_component_el_button, {
        type: "primary",
        class: "login-button",
        onClick: handleLogin
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t('login.btnTitle')), 1)];
        }),
        _: 1
      })], 64);
    };
  }
};